import { useEffect, useId, useRef } from 'react';

import { supabase } from '../supabase.js';
import { getPatrolId } from '../api.js';

export const useRealtimeTrigger = (domain, entity, callback, { onRemoved } = {}) => {
    const callbackRef = useRef(callback);
    const onRemovedRef = useRef(onRemoved);
    const instanceId = useId();

    useEffect(() => {
        callbackRef.current = callback;
        onRemovedRef.current = onRemoved;
    }, [ callback, onRemoved ]);

    useEffect(() => {
        const patrolId = getPatrolId();

        if (!patrolId) return;

        const channel = supabase
            .channel(`${ patrolId }-${ domain }-${ entity }-${ instanceId }`)
            .on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'realtime_triggers',
                filter: `patrol_id=eq.${ patrolId }`
            }, (payload) => {
                const row = payload.new ?? payload.old;

                if (row?.domain !== domain || row?.entity !== entity) return;

                if (payload.eventType === 'DELETE' && onRemovedRef.current) {
                    onRemovedRef.current(payload.old.entity_id);
                } else if (callbackRef.current) {
                    callbackRef.current(payload.new.entity_id);
                }
            })
            .subscribe();

        return () => { supabase.removeChannel(channel); };
    }, [ domain, entity, instanceId ]);
};
